import React, { useState, useEffect } from "react";
import "../LoginPage/Login.css";
import EliteMembersimglogin from "../../../Assets/Images/hrms.jpg";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import FloatingLabelInput from "../../../Components/floatingLabel/FloatingLabel";
import {
  Apiurl,
  SetLoginRole,
  Token,
  GetLoginRole,
  GetToken,
} from "../../../Utils/utils";
import Loader from "../../../Components/loader/loader";
import eliteLoginlogo from "../../../Assets/Images/logo-elite-for login.png";

const Login = () => {
  const navigate = useNavigate();
  const [newPasswordEye, setNewPasswordEye] = useState(false);
  const [changePassword, setChangePassword] = useState("");
  const [username, setUsername] = useState("");
  const [errorusername, setErrorusername] = useState(false);
  const [errorpassword, setErrorpassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const handleClickNewPassword = () => {
    setNewPasswordEye(!newPasswordEye);
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validate = () => {
    if (!username) {
      setErrorusername("required");
      return false;
    }

    if (!isValidEmail(username)) {
      setErrorusername("invalid");
      return false;
    }

    if (!changePassword) {
      setErrorpassword("required");
      return false;
    }

    return true;
  };

  const handleForgotPassword = () => {
    navigate("/ForgotPassword");
  };

  const handleLoginSubmit = (e) => {
    e?.preventDefault();

    if (!validate()) return;

    setLoading(true);

    const data = {
      EmailAddress: username,
      Password: changePassword,
    };

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
      },
      data: { data: JSON.stringify(data) },
      url: `${Apiurl()}/Account/LoginUser`,
    };

    axios(option)
      .then((response) => {
        if (response?.data?.success) {
          if (response?.data?.message === "TeamLead successfully") {
            toast.success("Team Lead Login Successfully");
          } else if (response?.data?.message === "HR successfully") {
            toast.success("HR Login Successfully");
          } else {
            toast.success(response?.data?.message || "Login Successfully");
          }

          const userToken = response?.data?.data?.token;
          const roleName = response?.data?.data?.roleName;

          if (!userToken) {
            setLoading(false);
            toast.error("Token not received from server.");
            return;
          }

          Token(userToken, rememberMe);
          SetLoginRole(roleName, rememberMe);

          setUsername("");
          setChangePassword("");
          setLoading(false);

          if (
            roleName === "Employee" ||
            roleName === "TeamLead" ||
            roleName === "HR" ||
            roleName === "Manager"
          ) {
            navigate("/Emp/Dashboard", { replace: true });
          } else {
            navigate("/Adm/Dashboard", { replace: true });
          }
        } else {
          setLoading(false);
          toast.error(response?.data?.message || "Login failed.");
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(
          err?.response?.data?.message || "An error occurred during login."
        );
      });
  };

  useEffect(() => {
    const token = GetToken();
    const role = GetLoginRole();

    if (token && role) {
      if (role === "Admin") {
        navigate("/Adm/Dashboard", { replace: true });
      } else {
        navigate("/Emp/Dashboard", { replace: true });
      }
    }
  }, [navigate]);

  return (
    <>
      {loading ? <Loader /> : null}

      <div className="full-page-main">
        <div className="main-container-of-login-page row">
          <div className="login-page-image col-md-6">
            <img src={EliteMembersimglogin} alt="" />
          </div>

          <div className="login-page-form col-md-6">
            <div className="inner-container-of-login-form">
              <div className="eliteLoginlogo-main-div">
                <img src={eliteLoginlogo} alt="" />
              </div>

              <div className="elite-heading-div">
                <h2>
                  Welcome To <span className="elite-heading">Elite</span> HRMS
                </h2>

                <form onSubmit={handleLoginSubmit} autoComplete="on">
                  <div className="email-and-password-inputs">
                    <div>
                      <div className="username-content-login">
                        <FloatingLabelInput
                          label="Username*"
                          type="email"
                          autoComplete="username"
                          value={username}
                          onChange={(e) => {
                            setUsername(e.target.value);
                            setErrorusername(null);
                          }}
                          onBlur={(e) => {
                            const value = e.target.value;

                            if (!value) {
                              setErrorusername("required");
                            } else if (!isValidEmail(value)) {
                              setErrorusername("invalid");
                            } else {
                              setErrorusername(null);
                            }
                          }}
                        />

                        {errorusername === "required" && (
                          <span className="contact_error-login">
                            Username is required.
                          </span>
                        )}

                        {errorusername === "invalid" && (
                          <span className="contact_error-login">
                            Enter a valid Username.
                          </span>
                        )}
                      </div>

                      <div className="password-floating-login">
                        <FloatingLabelInput
                          label="Password*"
                          type={newPasswordEye ? "text" : "password"}
                          autoComplete="current-password"
                          value={changePassword}
                          onChange={(e) => {
                            setChangePassword(e.target.value);
                            setErrorpassword(null);
                          }}
                          onBlur={(e) => {
                            if (!e.target.value) {
                              setErrorpassword("passworddata");
                            } else {
                              setErrorpassword(null);
                            }
                          }}
                        />

                        {newPasswordEye ? (
                          <AiOutlineEye
                            className="eye-password-login"
                            onClick={handleClickNewPassword}
                          />
                        ) : (
                          <AiOutlineEyeInvisible
                            className="eye-password-login"
                            onClick={handleClickNewPassword}
                          />
                        )}

                        {errorpassword === "passworddata" && !changePassword ? (
                          <span className="contact_error-login">
                            Password is required.
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="remember-me-and-forgot-password">
                    <div className="remember-me-input-label">
                      <input
                        type="checkbox"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                      />
                      <label>Remember me</label>
                    </div>

                    <div className="forgot-password">
                      <p onClick={handleForgotPassword}>Forgot Password?</p>
                    </div>
                  </div>

                  <div className="login-button-login">
                    <button
                      type="submit"
                      disabled={
                        loading ||
                        !username ||
                        !changePassword ||
                        !isValidEmail(username)
                      }
                    >
                      Login
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;